module.exports = __webpack_public_path__ + "static/media/2010 Vienna, Austria.0e3be676.jpg";